import {
  type Dispatch,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';
import {
  type CreateThemeType,
  type DefaultThemeType,
  baseTheme,
  createTheme,
} from '../../components/global-tabs/AppTabs/theme';

export const UserSettingsContext = createContext<{
  theme: DefaultThemeType;
  setTheme: (
    newTheme: CreateThemeType
  ) => Dispatch<SetStateAction<DefaultThemeType>> | undefined;
}>({
  theme: baseTheme,
  setTheme: () => {},
});

export const useUserSettings = () => {
  return useContext(UserSettingsContext);
};

export const UserSettingsContextProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const [theme, setTheme] = useState<DefaultThemeType>(baseTheme);
  const handleSetTheme = (newTheme: CreateThemeType) => {
    setTheme(createTheme(newTheme));
  };

  return (
    <UserSettingsContext.Provider
      value={{
        theme,
        setTheme: handleSetTheme,
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
};
